import gql from 'graphql-tag';

const query = gql`
  query UserAccess {
    me {
      id
      diet {
        id
        accessTo
        lifetimeAccess
      }
      videoWorkout {
        accessTo
        lifetimeAccess
      }
      activeSubscriptions {
        id
        givesAccessToDiet
        givesAccessToVideoWorkouts
        renewalDate
        operator
      }
    }
  }
`;

export default query;
